<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageBottom>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content"> 
              <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/marketing/services.jpg" alt=""></transition></div>                                     
                <div class="page-content content">
                  <transition name="slide-fade" mode="out-in" appear>
                    <TitleContent h2="Marketing" h1="Services" />                    
                  </transition>
                  <transition name="slide-fade" mode="out-in" appear>
                    <div class="text-content">
                        <p class='large yellow'>Allegiant Stadium and the Las Vegas Raiders offer national and global marketing expertise.</p>
                        <p>The stadium’s full-service marketing department is prepared to assist and collaborate with clients on all event marketing services such as media buying and placement, digital strategy, public relations, and creative design. </p>
                    </div>                    
                  </transition>
                </div>
            </div>
        </div>
    </template>
    </PageBottom>    
  </div>
</template>

<script>
import PageBottom from "@/patterns/PageBottom.vue";
import TitleContent from "@/patterns/TitleContent.vue";
export default {
  name: "TheStadium",
  components: { PageBottom, TitleContent },
  data: () => ({
    scrollContent: false,    
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>
<style scoped>
  .image img{object-position: center;}
</style>